import style from "./Button.module.css"
import {useEffect, useState} from "react";
import MediaQueryUtils from "../../utils/MediaQueryUtils";

// const btnBase = "btn btnBlu";
// const btnOut = "btn btnBluOutline";
// const btnDis = "btn btn-primary disabled btnDisabled";
// const btnDisOut = "btn disabled btnDisabledOutline";
//
// const btnViola = "btn btnViola";
// const btnViolaOut = "btn btnOutlineViola";
//
// const btnWarning = "btn btnWarning";
// const btnWarningOut = "btn btnWarningOutline";


function Button(props) {

    const [className, setClassName] = useState("")

    let isPageWide = MediaQueryUtils('(min-width: 800px)')

    useEffect(() => {
        if (props.typeButton === "Blue") {
            setClassName(style.btnBlu)
        } else if (props.typeButton === "White") {
            setClassName(style.btnWhite)
        }
    })

    return (
        <>
        <button
            data-toggle={props.dataToggle}
            data-target={"#".concat(props.dataTarget)}
            data-dismiss={props.dataDismiss}
            data-keyboard={props.dataKeyboard}
            data-backdrop={props.dataBackdrop}
            type={"button"}
            id={props.id}
            onClick={props.onClick}
            style={props.style}
            disabled={props.disabled}
            className={className.concat(" ").concat(props.className)}
        ><div className={"row"} style={{justifyContent:"center"}}>
            {props.icon ? props.icon : ''}
            <span style={{paddingTop:props.icon ?"0.1rem":""}}>{props.text}</span>
        </div>
        </button>


            <div className="modal fade" id={props.dataTarget} tabIndex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className={"modal-dialog ".concat(style.alignModal)} role="document" >
                    <div className="modal-content" style={{width: isPageWide ? "700px" : "600px"}}>
                        <div className="modal-header" style={{alignSelf: "center"}}>
                            <p className={style.fontHeaderModal}>{props.header}</p>
                        </div>
                        <div className="modal-body">
                            {props.body}
                        </div>
                    </div>
                </div>
            </div>

        </>
    );


}

export default Button
